import qs from "qs"; // For query string manipulation
import axios from "axios"; // For making HTTP requests
import { syncBackendToken } from "../Redux/Helper/fetch";
import { redirectToFronteggLogout } from "../authSession";

const checkHTTPStatus = () => {};

async function retryAfterBackendSync(request, res) {
  if (res.status !== 401) {
    return res;
  }

  try {
    await syncBackendToken();
    return request();
  } catch (error) {
    redirectToFronteggLogout();
    return res;
  }
}

// Function to make GET API calls
export const get = async (url, body) => {
  let data;
  try {
    const customHeaders = {
      "Content-Type": "application/json",
    };
    const auth = localStorage.getItem("token");
    if (auth) {
      customHeaders.authorization = auth;
    }
    let res = null;
    const request = () => {
      const latestHeaders = {
        ...customHeaders,
      };
      const latestAuth = localStorage.getItem("token");
      if (latestAuth) {
        latestHeaders.authorization = latestAuth;
      }

      return body ? fetch(`${url}?${qs.stringify(body)}`, {
        method: "get",
        headers: latestHeaders,
      }) : fetch(url, {
        method: "get",
        headers: latestHeaders,
      });
    };
    res = await request();
    res = await retryAfterBackendSync(request, res);
    data = await res.json();
    return data;
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};

// Function to make POST API calls
export const post = async (url, body) => {
  let data;
  try {
    const customHeaders = {
      "Content-Type": "application/json",
    };
    const auth = localStorage.getItem("token");
    customHeaders.authorization = auth;

    const request = () => {
      const latestHeaders = {
        ...customHeaders,
        authorization: localStorage.getItem("token"),
      };

      return fetch(url, {
      method: "POST",
      headers: latestHeaders,
      body: JSON.stringify(body),
      });
    };
    let res = await request();
    res = await retryAfterBackendSync(request, res);
    data = await res.json();
    if (data.status) {
      return data;
    }
    if (!data.status) {
      let error = new Error(data.message);
      error = data;
      throw error;
    }
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};

// Function to make POST API calls for file uploads
export const postFile = async (url, body) => {
  const formData = body;
  try {
    const customHeaders = {
      "Content-Type": "multipart/form-data",
    };
    const auth = localStorage.getItem("token");
    customHeaders.authorization = auth;

    const data = await axios.post(url, formData, {
      headers: customHeaders,
    });

    if (data.status) {
      return data;
    }
    if (!data.status) {
      let error = new Error(data.message);
      error = data;
      throw error;
    }
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};

// Function to make PUT API calls
export const put = async (url, body, formData = false) => {
  let data;
  const bodyValue = body;
  try {
    const customHeaders = {
      "Content-Type": "application/json",
    };
    const auth = localStorage.getItem("token");
    if (auth) {
      customHeaders.authorization = auth;
    }
    let res = null;
    if (formData) {
      const request = () => fetch(url, {
        method: "PUT",
        headers: { authorization: localStorage.getItem("token") },
        Accept: "application/json",
        body: bodyValue,
      });
      res = await request();
      res = await retryAfterBackendSync(request, res);
    }
    if (!formData) {
      const request = () => {
        const latestHeaders = {
          ...customHeaders,
        };
        const latestAuth = localStorage.getItem("token");
        if (latestAuth) {
          latestHeaders.authorization = latestAuth;
        }

        return fetch(url, {
        method: "PUT",
        headers: latestHeaders,
        body: JSON.stringify(bodyValue),
        });
      };
      res = await request();
      res = await retryAfterBackendSync(request, res);
    }
    data = await res.json();
    if (data.status) {
      return data;
    }
    if (!data.status) {
      let error = new Error(data.message);
      error = data;
      throw error;
    }
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};

// Function to make GET API calls with alternate payment headers
export const getAltPay = async (url, body) => {
  let data;
  try {
    const customHeaders = {
      "Content-Type": "application/json",
      publicKey: process.env.REACT_APP_KEY_AUTH_PUBLIC_KEY,
      privateKey: process.env.REACT_APP_KEY_AUTH_PRIVATE_KEY,
    };
    let res = null;
    if (body) {
      res = await fetch(`${url}?${qs.stringify(body)}`, {
        method: "get",
        headers: customHeaders,
      });
    } else {
      res = await fetch(url, {
        method: "get",
        headers: customHeaders,
      });
    }
    data = await res.json();
    checkHTTPStatus(res.status);
    return data;
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};

// Function to make POST API calls with alternate payment headers
export const postAltPay = async (url, body) => {
  let data;
  try {
    const customHeaders = {
      "Content-Type": "application/json",
    };
    customHeaders.token = body.header.token;

    const res = await fetch(url, {
      method: "POST",
      headers: customHeaders,
      body: JSON.stringify(body.body),
    });
    data = await res.json();
    checkHTTPStatus(res.status);
    if (data) {
      return data;
    }
    if (!data.status) {
      let error = new Error(data.message);
      error = data;
      throw error;
    }
  } catch (e) {
    if (e) {
      throw e;
    }
  }
};
